import React from "react";
import {
  Box,
  Card,
  Container,
  Typography,
  // Button,
  // Tooltip,
} from "@material-ui/core";
import { useRecoilValue } from "recoil";
import {
  // successStoryListingState,
  // successStoryArchiveListState,
  // archiveListCountState,
  isArchiveState,
} from "Recoil/SuccessStory/atom";
// import { checkArrayLength } from "src/utils";
import KendoTabContent from "./KendoTabContent";
import { useStyles } from "./styles";
// import ConfirmationModal from "Components/modal/Modal/ConfirmationModal";
// import ArchiveIcon from "Assets/images/archive.svg";
// import ArchiveBucketIcon from "Assets/images/archive-bucket.svg";
// import { get } from "lodash";
import { useHistory, useParams } from "react-router-dom";

// import { useSuccessStory } from "Hooks/successStory/useSuccessStory";
// import { ChevronLeft } from "@material-ui/icons";
import BulkActions from "./BulkActions";
// import PageHeader from "Components/PageHeader";
import SuccessStoriesReport from "../SuccessStoriesReport";

const SuccessStoryKendo = () => {
  const classes = useStyles();
  const history = useHistory();
  // const successStories = useRecoilValue(successStoryListingState);
  // const { archivedSuccessStoriesCount } = useRecoilValue(archiveListCountState);
  const pathname = history.location.pathname;
  // const isArchive = pathname.includes("archive");
  const isArchive = useRecoilValue(isArchiveState)

  const action = pathname.includes("successstories")
    ? "successStory"
    : "performanceReview";
  const { id } = useParams();

  // const getArchivedList = () => {
  //   {
  //     action === "successStory"
  //       ? history.push(`${REPORTS}${SUCCESS_STORIES}${ARCHIVE}`)
  //       : history.push(`${REPORTS}${PERFORMANCE_REVIEW}${ARCHIVE}`);
  //   }
  // };
  if (id) {
    return (
      <Container maxWidth="lg">
        {/* <PageHeader
          title={
            action === "successStory" ? "Success story" : "Performance review"
          }
          containerWidth="lg"
        /> */}
        <SuccessStoriesReport />
      </Container>
    );
  }
  return (
    <Container maxWidth={"lg"}>
      <Card className={classes.root}>
        <Box px={3} pt={3} pb={2} position="relative">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {/* {!isArchive ? ( */}
              <Typography variant="body2" className="font-semibold">
                {action === "successStory"
                  ? "Success stories"
                  : "Performance reviews"}
                {/* ({checkArrayLength(successStories)}) */}
              </Typography>
            {/* ) : (
              <Typography variant="body2" className="font-semibold">
                {action === "successStory"
                  ? "Archived success stories"
                  : "Archived performance review"}
                ({checkArrayLength(successStories)})
              </Typography>
            )} */}
            <Box display="flex" alignItems="center">

              <BulkActions action={action} />
            </Box>
          </Box>
          <Box mt={3}>
            <KendoTabContent dashboardAction={action} pageType="reports" />
          </Box>
        </Box>
      </Card>
    </Container>
  );
};

export default SuccessStoryKendo;
